import React from 'react';
import { Sparkles } from 'lucide-react';

export default function CourseHero({ course, onBack, onOpenTutor }) {
  return (
    <div className="bg-gradient-to-br from-purple-900/50 to-gray-900 border-b border-gray-800">
      <div className="container mx-auto px-4 py-12">
        <button
          onClick={onBack}
          data-testid="course-back-button"
          className="text-gray-400 hover:text-white mb-6 flex items-center gap-2"
        >
          ← Back to Catalog
        </button>

        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <div className="flex items-center gap-4 mb-4">
              <span className="px-4 py-1 bg-purple-600 rounded-full text-sm font-semibold">{course.subject}</span>
              <span className="text-gray-400">{course.level}</span>
            </div>

            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-testid="course-detail-title">
              {course.title}
            </h1>
            <p className="text-xl text-gray-300 mb-6">{course.description}</p>

            <div className="flex items-center gap-6 mb-6">
              <div>
                <div className="text-sm text-gray-400">Instructor</div>
                <div className="font-semibold">{course.instructor}</div>
              </div>
              <div>
                <div className="text-sm text-gray-400">Duration</div>
                <div className="font-semibold">{course.duration}</div>
              </div>
              <div>
                <div className="text-sm text-gray-400">Modules</div>
                <div className="font-semibold">{course.modules?.length || 0}</div>
              </div>
            </div>

            <div className="flex items-center gap-4 flex-wrap">
              <div className="text-3xl font-bold text-purple-400" data-testid="course-hero-price">
                {course.price === 0 ? (
                  'FREE'
                ) : (
                  <>
                    {Math.ceil(course.price / 5)} Tokens
                    <span className="ml-2 text-base text-gray-400 font-mono">
                      / ${course.price}
                    </span>
                  </>
                )}
              </div>
              {course.price > 0 ? (
                <button
                  type="button"
                  onClick={() => {
                    if (typeof window !== 'undefined') {
                      window.dispatchEvent(new CustomEvent('scholar:open-redeem'));
                    }
                  }}
                  data-testid="course-enroll-button"
                  data-action="open-redeem"
                  className="bg-amber-500 hover:bg-amber-400 text-black px-8 py-3 rounded-lg font-semibold shadow-lg transition-colors"
                >
                  Enroll Now — Redeem {Math.ceil(course.price / 5)} Tokens
                </button>
              ) : (
                <button
                  data-testid="course-enroll-button"
                  data-action="enroll-free"
                  className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-3 rounded-lg font-semibold shadow-lg transition-colors"
                >
                  Enroll Free
                </button>
              )}
              <button
                onClick={onOpenTutor}
                data-testid="course-open-tutor"
                className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-6 py-3 rounded-lg font-semibold shadow-lg transition-colors flex items-center gap-2"
              >
                <Sparkles className="w-5 h-5" />
                Ask the Instructor (AI)
              </button>
            </div>
          </div>

          <div className="bg-gray-900 rounded-2xl p-8 border border-gray-800">
            <h3 className="text-xl font-bold mb-6">What You'll Learn</h3>
            <ul className="space-y-3">
              {course.learning_outcomes?.slice(0, 6).map((outcome) => (
                <li key={outcome} className="flex items-start gap-3">
                  <svg className="w-5 h-5 text-green-400 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-300">{outcome}</span>
                </li>
              )) || <li className="text-gray-400">Learning outcomes coming soon</li>}
            </ul>

            {course.prerequisites && course.prerequisites.length > 0 && (
              <div className="mt-6 pt-6 border-t border-gray-800">
                <h4 className="font-semibold mb-3">Prerequisites</h4>
                <ul className="space-y-2">
                  {course.prerequisites.map((prereq) => (
                    <li key={prereq} className="text-sm text-gray-400">• {prereq}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
